import { ReactNode } from 'react'
import CopyButton from '@/components/copy-button'
import { cx } from '@/utils/strings'

export type CalloutProps = {
  contentful_id: string
  type: 'info' | 'warning' | 'success' | 'example'
  className?: string
  children: ReactNode
  hideHeader?: boolean
}

export default function Callout({ contentful_id: id, type, children, className, hideHeader = false }: CalloutProps) {
  const title = {
    warning: 'warning',
    info: 'note',
    success: 'tip',
    example: 'example',
  }
  const icons = {
    warning: '\ue94b',
    info: '\ue952',
    success: '\ue953',
    example: '\ue953',
  }
  return (
    <div className={cx('callout', className)}>
      {type === 'example' && (
        <div className="float-right">
          <CopyButton id={id} theme="light" className="text-sm" />
        </div>
      )}

      {!hideHeader && (
        <div className="flex items-center gap-2 mb-4">
          <span
            className={cx(
              'font-bwi text-3xl leading-[30px] font-light translate-y-px',
              type === 'warning' && `text-warning`,
              type === 'info' && `text-primary-700 dark:text-primary-100`,
              type === 'success' && `text-accent-teal`,
              type === 'example' && `text-bw-deep-blue dark:text-teal-600`
            )}
          >
            {icons[type]}
          </span>
          <h5 className={cx(`text-2xl leading-none capitalize py-0`)}>{title[type]}</h5>
        </div>
      )}
      <section id={id}>{children}</section>
    </div>
  )
}
